import {useParams} from "react-router-dom";
import styles from "./PPTInsertWaitingPage.module.css";
import Lottie from "react-lottie";
import {
    POLL_TYPE,
} from "../../utils/constants";
import { useTranslation } from "react-i18next";
import React from "react";
import addingSlides from "./animations/addingSlides_PowerPoint.json";
import YuJaButton from "../../components/standardization/YuJaButton";
import {usePPTWebView} from "../../hooks/usePPTWebView";

export default function PPTInsertWaitingPage() {
    const { t } = useTranslation();
    const { pollType } = useParams();
    const {goPollsPage} = usePPTWebView();


    const options = {
        loop: true,
        autoplay: true,
        animationData: addingSlides,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice",
        }
    };

    return (
        <div className={styles.container}>
            <div style={{flex: 1}}/>
            <Lottie
                options={options}
                height={260}
                width={260}
                isClickToPauseDisabled={true}
                style={{cursor: "default"}}
            />
            <span className={styles.title}>
                {pollType === POLL_TYPE.ATTENDANCE ? t("poll.insertingYourAttendance") : t("poll.insertingYourPoll")}

            </span>
            <div style={{height: 20}}/>
            <span className={styles.description}>
                {pollType === POLL_TYPE.ATTENDANCE
                    ? t("poll.insertingYourAttendanceDescription")
                    : t("poll.insertingYourPollDescription")
                }
            </span>
            <div style={{flex: 3}}/>
        </div>
    );
}